import { Claim } from "../../api/ClientFileApi";

export function isActiveClaim(claim: Claim): boolean {
  return !claim.isCompleted;
}

export function sumCurrentSaldo(claims: Claim[]): number {
  return claims.reduce((sum, c) => sum + c.currentSaldo, 0);
}
